(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailTable', {
            templateUrl: 'app/score-detail/score-detail-table/score-detail-table.component.html',
            controller: ScoreDetailTableComponent,
            bindings: { data: '<', showLabels: '<', onReady: '&' }
        });

    ScoreDetailTableComponent.$inject = ['$scope', '$timeout', 'fairwayHitType'];
    function ScoreDetailTableComponent($scope, $timeout, fairwayHitType) {
        var ctrl = this;

        // properties
        ctrl.holeScores = [];

        // methods
        ctrl.$onInit = init;
        ctrl.$postLink = postLink;
        ctrl.getCellClass = getCellClass;
        ctrl.getFirClass = getFirClass;
        ctrl.getType = getType;
        ctrl.isVisible = isVisible;

        ///////////////////////////////

        function init() {
            ctrl.holeScores = ctrl.data || [];
        }
        function getCellClass(holeNumber) {
            switch (holeNumber) {
                case 0: return 'cell-label';
                case 9.1: return 'cell-out';
                case 18.1: return 'cell-in';
                case 18.2: return 'cell-tot';
                default: return 'cell-' + holeNumber;
            }
        }
        function getFirClass(fir) {
            switch (fir) {
                case fairwayHitType.Hit: return 'fas fa-bullseye';
                case fairwayHitType.MissedShort: return 'fa fa-arrow-down';
                case fairwayHitType.MissedLong: return 'fa fa-arrow-up';
                case fairwayHitType.MissedLeft: return 'fa fa-arrow-left';
                case fairwayHitType.MissedRight: return 'fa fa-arrow-right';
                case fairwayHitType.MissedUnspecified: return 'far fa-circle';
                default: return null;
            }
        }
        function getType(item) {
            return typeof (item);
        }
        function postLink() {
            $timeout(function () { ctrl.onReady({ target: ctrl }); });
        }
        function isVisible(type) {
            var score = ctrl.holeScores.$parent,
                isHoleByHole = score.isHoleByHole,
                isTrackingStats = score.isTrackingStats;

            switch (type) {
                case 'holeNumber':
                case 'par':
                case 'gross':
                case 'esc': return isHoleByHole;
                default: return isHoleByHole && isTrackingStats;
            }
        }
    }
})();